import { Reducer as ReduxReducer } from "redux";
import { ActionTypes } from "./actions";
import { IAuthState } from "./state";
import { IToken } from "../../models";

import { AuthorizationService } from "../../services/authorization-service";

interface IUpdateAuth {
    type: string,
    token: IToken
}

interface IStoreAuth {
    type: string,
    token: IToken,
    tokenHex: string
}

interface IClearAuth {
    type: string
}

const updateAuth = (state: IAuthState, action: IUpdateAuth) => {
    AuthorizationService.setToken(action.token);
    state.authInfo = action.token;
    state.isAuthenticated = true;
    return state;
}

const storeAuth = (state: IAuthState, action: IStoreAuth) => {
    AuthorizationService.setToken(action.token);
    state.authInfo = action.token;
    state.tokenHex = action.tokenHex;
    state.isAuthenticated = true;
    return state;
}

const clearAuth = (state: IAuthState, action: IClearAuth) => {
    AuthorizationService.logout();
    state.authInfo = null;
    state.isAuthenticated = false;
    return state;
}

const createReducer = (initialState: IAuthState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const initialState: IAuthState = {
    authInfo: AuthorizationService.getToken(),
    tokenHex: "",
    isAuthenticated: AuthorizationService.isLoggedIn()
};

const handlers = {
    [ActionTypes.UPDATE_AUTH]: updateAuth,
    [ActionTypes.STORE_AUTH]: storeAuth,
    [ActionTypes.CLEAR_AUTH]: clearAuth
};

export const Reducer = createReducer(initialState, handlers);
